import { ClientLibraries } from "../config/Configuration";

export { ClientLibraries as CloudService };



// WEBPACK FOOTER //
// ./src/common/CloudService/ClientLibsReference.js